import { CONFIG } from '@/config-global';
import axios, { endpoints } from '@/utils/axios';
import { fetcher } from '@/utils/axios';
import useSWR from 'swr';

export type UserPreferences = {
  citationStyle?: string | null;
  citationFormat?: 'AUTHOR_YEAR' | 'NUMERIC' | null;
};

const USER_URL = `${CONFIG.serverUrl}${endpoints.user}`;

// ----------------------------------------------------------------------

export type Me = {
  id: string;
  name?: string | null;
  email?: string | null;
  profileImage?: string | null;
  isSuperadmin?: boolean;
  authMetadata?: Record<string, any> | null;
  authCapabilities?: {
    hasPasswordIdentity?: boolean;
  } | null;
  // This user's own LinkedIn SSO attributes, used only as editable intake
  // prefills (BON-794). Absent or null until LinkedIn SSO supplies them.
  ssoProfile?: {
    costCenter?: string | null;
    businessUnit?: string | null;
  } | null;
} | null;

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

export function useCurrentUser(enabled: boolean = true) {
  const key: any = enabled ? [`${USER_URL}`, { params: { endpoint: 'get-me' } }] : null;
  const { data, error, isLoading, isValidating, mutate } = useSWR<{ ok: boolean; user: Me }>(
    key,
    fetcher,
    swrOptions
  );

  return { me: data?.user || null, loading: isLoading, error, validating: isValidating, refresh: mutate };
}

export async function getCurrentUser(): Promise<Me> {
  try {
    const { data } = await axios.get(`${USER_URL}`, {
      params: { endpoint: 'get-me' },
    });
    return data?.user || null;
  } catch (error) {
    console.error('Failed to fetch current user:', error);
    return null;
  }
}
